import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICustomer } from "src/app/features/models/iuser.modal";
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
    constructor(private http: HttpClient) {}

    getAllCustomers(): Observable<ICustomer> {
        return this.http.get<ICustomer>(`${environment.baseUrl}customer/GetAllCustomers`);
    }
}